module.exports = __webpack_public_path__ + "img/upgrader.5b20bb3a.webp";